import { signUpWorking } from './actions';
import { signUp as postSignUp } from '../account/actions';

/**
 * signs a user up and creates all account data
 */
export default async function signUp(dispatch, form) {
  await dispatch(postSignUp(form));

  if (window.analytics && window.analytics.track) {
    window.analytics.track('sign-up-account-complete');
  }

  //  send appsFlyer event
  if (window.plugins && window.plugins.appsFlyer) {
    window.plugins.appsFlyer.setAppUserId(`${process.env.INTERCOM_ID}`);

    if (form.staffCount.value > 5 && form.staffCount.value <= 100) {
      window.plugins.appsFlyer.trackEvent('af_5_to_100', {});
    }
    window.plugins.appsFlyer.trackEvent('af_signup_completed', {
      af_revenue: form.staffCount.value * 5,
      af_currency: 'USD',
    });
  }
  dispatch(signUpWorking(false));
}



// WEBPACK FOOTER //
// ./src/store/signUp/lib.js